// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'openSans', 'openSans Fallback'"},"className":"__className_420557","variable":"__variable_420557"};